export function base64ToBlob(base64) {
  if (!base64) return null

  const base64Data = base64.split(',')[1]

  const byteCharacters = atob(base64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset++) {
    const byte = byteCharacters.charCodeAt(offset)
    byteArrays.push(byte)
  }

  const blob = new Blob([new Uint8Array(byteArrays)], { type: 'image/png' })

  return blob
}
